import React, { forwardRef } from 'react';
import classnames from 'classnames';
import { getSysFieldid } from '@platform/api';
import { Tooltip } from '@platform/base';
import ColGroup from './ColGroup';

export default forwardRef(function TableFooter(props, ref) {
    /**
     * —————————————————————————————————————— render —————————————————————————————————————— 
     */
    let {
        rows,
        rowHeight,
        columnInfo,
        totalConfig = {},
        isFixLeft,
        isFixRight,
        footer,
        locale,
        hasVerticalScrollBar,
        hasHorizontalScrollBar,
        scrollBarSize,
        fixedBottom,
        bodyWidth,
        checkboxConfig = {},
        store,
        fixedDistance,
    } = props;

    let {
        left: { leafColumns: leftColumns, offsets: leftOffsets },
        middle: { leafColumns: middleColumns },
        right: { leafColumns: rightColumns },
        leaf: { columns: leafColumns },
        useTotal,
    } = columnInfo;
    let { enable, render, text = locale['table_total'], /*'当前合计'*/ checkedText = locale['table0060'] /*'已选合计'*/ } = totalConfig;

    let horizontalScrollBarSize = hasHorizontalScrollBar ? scrollBarSize : 0;
    let verticalScrollBarSize = hasVerticalScrollBar ? scrollBarSize : 0;

    let showCheckedTotal = checkboxConfig.enable && store?.getCheckedKeys()?.size;
    let mergeColSpan = leftColumns.length >= 2 ? 2 : 1; // 有两列以上固定列时，合并前两列
    let checkedLeftColumns = [...leftColumns];
    let totalLeftColumns = [...leftColumns];
    let checkedMiddleColumns = [...middleColumns];

    if (mergeColSpan === 2) {
        checkedLeftColumns.splice(1, 1);
        totalLeftColumns.splice(1, 1);
    }

    return <>
        <div
            ref={ref}
            className={classnames(
                "table-wrapper",
                "table-next-footer-wrapper",
                { 'fix-bottom': fixedBottom },
            )}
            style={{
                bottom: fixedBottom ? horizontalScrollBarSize + fixedDistance : 'auto',
                width: fixedBottom ? bodyWidth : 'auto',
            }}
            fieldid={getSysFieldid('total-row')}
        >
            {typeof footer === 'function' && footer()}
            {(enable || useTotal) && <table className="table-next-footer">
                <ColGroup {...props}></ColGroup>
                {/* 总合计 */}
                <tfoot fieldid={getSysFieldid('all-total-row')}>
                    {typeof render === 'function'
                        ?
                        <tr style={{ height: rowHeight }}>
                            <td colSpan={leafColumns.length}>
                                {render()}
                            </td>
                        </tr>
                        :
                        <tr style={{ height: rowHeight }}>
                            {totalLeftColumns.map((column, index) => {
                                let { key, total, dataIndex, itemtype } = column,
                                    display = rows.length && rows.some(row => row.values[column.key]?.value) ? total?.(rows) : '';

                                return <td
                                    key={key}
                                    className={classnames(
                                        'table-next-body-cell',
                                        'fixed-left',
                                        {
                                            'is-fixing': isFixLeft,
                                            'last-left-column': index === leftColumns.length - 1,
                                            [`footer-type-${itemtype}`]: index > 0,
                                        },
                                        'sticky',
                                    )}
                                    colSpan={index === 0 ? mergeColSpan : 1}
                                    style={{ left: leftOffsets[dataIndex] }}
                                    fieldid={getSysFieldid(key)}
                                >
                                    {leftColumns.length === 0 && index === 0 && text}
                                    <Tooltip
                                        className="tooltip-word-color table-pagination-tip"
                                        placement="top"
                                        delay={1}
                                        overlay={index === 0 ? text : display}
                                    >
                                        {index === 0 ? text : display}
                                    </Tooltip>
                                </td>;
                            })}
                            {middleColumns.map((column, index) => {
                                let { key, total, itemtype } = column,
                                    display = rows.length && rows.some(row => row.values[column.key]?.value) ? total?.(rows) : '';

                                return <td
                                    key={key}
                                    className={`footer-type-${itemtype}`}
                                    fieldid={getSysFieldid(key)}
                                >
                                    {leftColumns.length === 0 && index === 0 && text}
                                    <Tooltip
                                        className="tooltip-word-color table-pagination-tip"
                                        placement="top"
                                        delay={1}
                                        overlay={display}
                                    >
                                        {display}
                                    </Tooltip>
                                </td>;
                            })}
                            {rightColumns.map((column) => {
                                let { key, total } = column,
                                    display = rows.length && rows.some(row => row.values[column.key]?.value) ? total?.(rows) : '';

                                return <td
                                    key={key}
                                    className={classnames(
                                        'table-next-body-cell',
                                        'fixed-right',
                                        {
                                            'is-fixing': isFixRight,
                                            'first-right-column': true,
                                        },
                                        'sticky',
                                    )}
                                    style={{ right: verticalScrollBarSize }}
                                    fieldid={getSysFieldid(key)}
                                >
                                    <Tooltip
                                        className="tooltip-word-color table-pagination-tip"
                                        placement="top"
                                        delay={1}
                                        overlay={display}
                                    >
                                        {display}
                                    </Tooltip>
                                </td>;
                            })}
                        </tr>
                    }
                </tfoot>

                {/* 勾选合计 */
                    showCheckedTotal ?
                        <tfoot className='checked-total' fieldid={getSysFieldid('selected-total-row')}>
                            <tr style={{ height: rowHeight }} id='checked-total-row'>
                                {checkedLeftColumns.map((column, index) => {
                                    let { key, checkedTotal, dataIndex, itemtype } = column,
                                        display = rows.length && rows.some(row => row.values[column.key]?.value) ? checkedTotal?.(rows) : '';
                                    return <td
                                        key={key}
                                        className={classnames(
                                            'table-next-body-cell',
                                            'fixed-left',
                                            {
                                                'is-fixing': isFixLeft,
                                                'last-left-column': index === leftColumns.length - 1,
                                                [`footer-type-${itemtype}`]: index > 0,
                                            },
                                            'sticky',
                                        )}
                                        style={{ left: leftOffsets[dataIndex] }}
                                        colSpan={index === 0 ? mergeColSpan : 1}
                                        fieldid={getSysFieldid(key)}
                                    >
                                        {leftColumns.length === 0 && index === 0 && checkedText}
                                        <Tooltip
                                            className="tooltip-word-color table-pagination-tip"
                                            placement="top"
                                            delay={1}
                                            overlay={index === 0 ? checkedText : display}
                                        >
                                            {index === 0 ? checkedText : display}
                                        </Tooltip>
                                    </td>;
                                })}
                                {checkedMiddleColumns.map((column, index) => {
                                    let { key, checkedTotal, itemtype } = column,
                                        display = rows.length && rows.some(row => row.values[column.key]?.value) ? checkedTotal?.(rows) : '';

                                    return <td
                                        key={key}
                                        className={`footer-type-${itemtype}`}
                                        fieldid={getSysFieldid(key)}
                                    >
                                        {leftColumns.length === 0 && index === 0 && checkedText}
                                        <Tooltip
                                            className="tooltip-word-color table-pagination-tip"
                                            placement="top"
                                            delay={1}
                                            overlay={display}
                                        >
                                            {display}
                                        </Tooltip>
                                    </td>;
                                })}
                                {rightColumns.length > 0 && <td
                                    className={classnames(
                                        'table-next-body-cell',
                                        'fixed-right',
                                        {
                                            'is-fixing': isFixRight,
                                            'first-right-column': true,
                                        },
                                        'sticky',
                                    )}
                                    style={{ right: verticalScrollBarSize }}
                                    colSpan={rightColumns.length}
                                ></td>}
                            </tr>
                        </tfoot>
                        : null
                }
            </table>}
            {renderScrollBarBlank()}
        </div>
        {fixedBottom && <div style={{
            height: ref.current.offsetHeight,
            width: bodyWidth,
            flex: 'none',
        }}></div>}
    </>;

    function renderScrollBarBlank() {
        return hasVerticalScrollBar && <div className="scroll-bar-blank" style={{ width: verticalScrollBarSize }}></div>;
    }
});